// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserSeries_container__Q-kPQ {
    max-width: 1000px;
    margin: 0 auto;
    padding: 20px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background-color: #121212;
    color: #f5f5f5;
  }
  
  .UserSeries_title__xaC8h {
    text-align: center;
    margin-bottom: 30px;
    color: #d3d3d3; /* Netflix-like red */
  }
  
  .UserSeries_imageGrid__EWQP3 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    margin-bottom: 30px;
    width: 76%;
    margin-left: auto;
    margin-right: auto;
  }
  
  .UserSeries_imageCard__bOMzs {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    transition: transform 0.3s ease;
  }
  
  .UserSeries_imageCard__bOMzs:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(229, 9, 20, 0.3);
  }
  
  .UserSeries_image__zIye5 {
    width: 100%;
    height: auto;
    display: block;
    cursor: pointer;
  }
  
  .UserSeries_pagination__So4Uq {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .UserSeries_pageButton__uRVVv {
    padding: 8px 16px;
    background-color: #e50914;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.2s ease;
  }
  
  .UserSeries_pageButton__uRVVv:disabled {
    background-color: #4d4d4d;
    cursor: not-allowed;
  }
  
  .UserSeries_pageButton__uRVVv:hover:not(:disabled) {
    background-color: #b30710;
  }
  
  .UserSeries_pageNumbers__gGncF {
    display: flex;
    margin: 0 15px;
  }
  
  .UserSeries_pageNumberButton__sxr\\+n {
    width: 35px;
    height: 35px;
    margin: 0 5px;
    border: 1px solid #333;
    background-color: #1e1e1e;
    color: #f5f5f5;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
  }
  
  .UserSeries_pageNumberButton__sxr\\+n:hover {
    background-color: #333;
    border-color: #e50914;
  }
  
  .UserSeries_pageNumberButton__sxr\\+n.UserSeries_active__\\+S2fo {
    background-color: #e50914;
    color: white;
    border-color: #e50914;
  }
  
  .UserSeries_pageInfo__mi8jT {
    text-align: center;
    color: #a0a0a0;
    font-size: 14px;
  }
  
  /* Responsive design */
  @media (max-width: 768px) {
    .UserSeries_imageGrid__EWQP3 {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  
  @media (max-width: 480px) {
    .UserSeries_imageGrid__EWQP3 {
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
    }
    
    .UserSeries_pageNumbers__gGncF {
      display: none;
    }
    
    .UserSeries_pageInfo__mi8jT {
      margin: 0 15px;
    }
    .UserSeries_imageGrid__EWQP3 {
      width: 90%;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/reading-pages/components/Css/UserSeries.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,wIAAwI;IACxI,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,cAAc,EAAE,qBAAqB;EACvC;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;IAC3B,4CAA4C;EAC9C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA,sBAAsB;EACtB;IACE;MACE,qCAAqC;IACvC;EACF;;EAEA;IACE;MACE,qCAAqC;MACrC,SAAS;IACX;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,cAAc;IAChB;IACA;MACE,UAAU;IACZ;EACF","sourcesContent":[".container {\n    max-width: 1000px;\n    margin: 0 auto;\n    padding: 20px;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    background-color: #121212;\n    color: #f5f5f5;\n  }\n  \n  .title {\n    text-align: center;\n    margin-bottom: 30px;\n    color: #d3d3d3; /* Netflix-like red */\n  }\n  \n  .imageGrid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 2rem;\n    margin-bottom: 30px;\n    width: 76%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  \n  .imageCard {\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n    transition: transform 0.3s ease;\n  }\n  \n  .imageCard:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 6px 12px rgba(229, 9, 20, 0.3);\n  }\n  \n  .image {\n    width: 100%;\n    height: auto;\n    display: block;\n    cursor: pointer;\n  }\n  \n  .pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 15px;\n  }\n  \n  .pageButton {\n    padding: 8px 16px;\n    background-color: #e50914;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: background-color 0.2s ease;\n  }\n  \n  .pageButton:disabled {\n    background-color: #4d4d4d;\n    cursor: not-allowed;\n  }\n  \n  .pageButton:hover:not(:disabled) {\n    background-color: #b30710;\n  }\n  \n  .pageNumbers {\n    display: flex;\n    margin: 0 15px;\n  }\n  \n  .pageNumberButton {\n    width: 35px;\n    height: 35px;\n    margin: 0 5px;\n    border: 1px solid #333;\n    background-color: #1e1e1e;\n    color: #f5f5f5;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n  }\n  \n  .pageNumberButton:hover {\n    background-color: #333;\n    border-color: #e50914;\n  }\n  \n  .pageNumberButton.active {\n    background-color: #e50914;\n    color: white;\n    border-color: #e50914;\n  }\n  \n  .pageInfo {\n    text-align: center;\n    color: #a0a0a0;\n    font-size: 14px;\n  }\n  \n  /* Responsive design */\n  @media (max-width: 768px) {\n    .imageGrid {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .imageGrid {\n      grid-template-columns: repeat(2, 1fr);\n      gap: 10px;\n    }\n    \n    .pageNumbers {\n      display: none;\n    }\n    \n    .pageInfo {\n      margin: 0 15px;\n    }\n    .imageGrid {\n      width: 90%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UserSeries_container__Q-kPQ`,
	"title": `UserSeries_title__xaC8h`,
	"imageGrid": `UserSeries_imageGrid__EWQP3`,
	"imageCard": `UserSeries_imageCard__bOMzs`,
	"image": `UserSeries_image__zIye5`,
	"pagination": `UserSeries_pagination__So4Uq`,
	"pageButton": `UserSeries_pageButton__uRVVv`,
	"pageNumbers": `UserSeries_pageNumbers__gGncF`,
	"pageNumberButton": `UserSeries_pageNumberButton__sxr+n`,
	"active": `UserSeries_active__+S2fo`,
	"pageInfo": `UserSeries_pageInfo__mi8jT`
};
export default ___CSS_LOADER_EXPORT___;
